// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_submissions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { FreezeDocumentVersionForSubmissionRequest, FreezeDocumentVersionForSubmissionResponse, ListProposalSubmissionsRequest, ListProposalSubmissionsResponse, RecordProposalSubmissionRequest, RecordProposalSubmissionResponse } from "./proposal_submissions_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Browser facade via sabaody; tenant and recorder come from the principal.
 *
 * @generated from service mono.projectdata.v1.ProposalSubmissionService
 */ export const ProposalSubmissionService = {
    typeName: "mono.projectdata.v1.ProposalSubmissionService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.ProposalSubmissionService.RecordProposalSubmission
     */ recordProposalSubmission: {
            name: "RecordProposalSubmission",
            I: RecordProposalSubmissionRequest,
            O: RecordProposalSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProposalSubmissionService.ListProposalSubmissions
     */ listProposalSubmissions: {
            name: "ListProposalSubmissions",
            I: ListProposalSubmissionsRequest,
            O: ListProposalSubmissionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-30: freeze one ONLYOFFICE volume document version for a submission:
     * export it with comments stripped (WRT-13 ExportDocumentVersion), store it
     * as a tesoro artifact in the project and label the version 'submitted'.
     * The caller adds the returned artifact to RecordProposalSubmission.files.
     * Needs the proposal's manager plus FND-25 proposal.document_export.
     *
     * @generated from rpc mono.projectdata.v1.ProposalSubmissionService.FreezeDocumentVersionForSubmission
     */ freezeDocumentVersionForSubmission: {
            name: "FreezeDocumentVersionForSubmission",
            I: FreezeDocumentVersionForSubmissionRequest,
            O: FreezeDocumentVersionForSubmissionResponse,
            kind: MethodKind.Unary
        }
    }
};
